import { put, call, CallEffect, PutEffect, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { Action } from 'redux-saga';
import { setCustomer } from '@/redux/ducks/customer';
import { getUserProductApi } from '@/settings/api';
import environment from '@/settings/environment';
import { ReducersTypes } from '@/redux/reducers/Models';
import { Vehicle } from '@/pages/auth/vehicles/Models';
import { mergeVehicleLists } from './utils';

export interface Fetch {
    callback?: (success: boolean) => void;
}

export interface GetVehiclesAction {
    type: string;
    payload: Fetch;
}

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* getVehicles({
    payload,
}: GetVehiclesAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        yield put(setCustomer({ isLoadingVehicles: true }));

        const { path, pageSize } = environment.api.userProduct;
        const userProductApi = getUserProductApi();

        let fromPage = 1;
        let totalPages = 1;
        let allListVehicle: Vehicle[] = [];
        let allListGarageVehicle: Vehicle[] = [];
        let products: unknown;

        do {
            const response = yield call(
                userProductApi.get,
                `${path}?offset=${pageSize}&fromPage=${fromPage}`
            );

            if (response?.data?.contractedProductPagination?.totalPages) {
                totalPages = response.data.contractedProductPagination.totalPages;
            }

            if (Array.isArray(response?.data?.listVehicle)) {
                allListVehicle = [...allListVehicle, ...response.data.listVehicle];
            }
            if (Array.isArray(response?.data?.listGarageVehicle)) {
                allListGarageVehicle = [...allListGarageVehicle, ...response.data.listGarageVehicle];
            }
            if (response?.data?.products) {
                products = response.data.products;
            }

            fromPage++;
        } while (fromPage <= totalPages);

        const vehicles = mergeVehicleLists(allListVehicle, allListGarageVehicle);

        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomer);
        const shouldInitializeSelectedVehicles = (vehicles?.length ?? 0) > 0 &&
          (!customer?.selectedVehicles || customer.selectedVehicles.length === 0);

        yield put(
            setCustomer({
                isLoadingVehicles: false,
                products,
                vehicles,
                ...(shouldInitializeSelectedVehicles && vehicles?.[0]?.plate && { selectedVehicles: [vehicles[0].plate] })
            })
        );
        if (payload?.callback) yield call(payload.callback, true);
    } catch (error) {
        yield put(setCustomer({ isLoadingVehicles: false }));
        if (payload?.callback) yield call(payload.callback, false);
    }
}
